/*@ngInject*/
const CollaborationCreateTaskRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.createCollaborationTask = function (data) {
        let url = '/rest/SubmissionTask';

        return this.post(url, data);
    };
};

angular.module('gw-um-submission')
    .service('collaborationCreateTaskRepository', CollaborationCreateTaskRepository);
